import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {withRouter } from "react-router-dom";
// import { TopbarGrid, IconsWrapper, IconContainer, NameContainer, Languagecontainer, SvgIconContainer, Logo, ArrowImg, CollapsArrow } from './style';
import { TopbarGrid, IconsWrapper, NameContainer, Logo, /*ArrowImg,*/ CollapsArrow, IconContainer, /*Languagecontainer,*/ ProfileImg, ManagerIconContainer, StyledImage, /*ViewButton*/ } from './style';
//import {ProfileContainer,Settings} from '../TopBarV2/style'
import { ImageUrl } from '../../utils/constants';
import Notification from '../Notification';
import { COMPANY_NAME } from '../../utils/config';
import UserProfile from '../UserProfile';
import { putUpdateLanguage } from '../../redux/actions';
import { connect } from 'react-redux';
import i18n from '../../Lang/i18n';
import  {Img}  from "react-image";
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import { withTranslation } from 'react-i18next';
import {  DropIcon, LightThemeIcon } from '../../utils/icons';
import { Dropdown } from 'react-bootstrap';
import styled from 'styled-components';
import { Border } from '../EventDetails/styles';

const checkBase64 = (image) => {
  let arr = image.split('/');
  if (arr[0] == 'profile-Image') {
    return `${ImageUrl}/${image}`
  }
  else {
    return image;
  }
};



export const CustomToggle = styled.div`
  display: flex;
  align-items: center;
  height: 20px;
  padding: 0 5px; 
  font-size: 16px;
  cursor: pointer;
  color:#184A61;
  font-family:lato;

  &::after {
    display: none !important;
  }

`;


export const DropdownWrapper = styled.div`
  display: flex;
  align-items: center;
  position: ${({ isPosition }) => (isPosition ? "" : "relative")};
  cursor: pointer;
  ${'' /* margin:0px 20px; */}
  margin: ${({ isMargin }) => (isMargin ? isMargin : "0px 20px")};
`;


export const CustomToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px; 
`;


export const CustomMenuV1 = styled(Dropdown.Menu)`
  border: 1px solid #EFEFEF !important;
  border-radius: 4px !important;
  min-width: 136px !important; 
  padding: 0px !important;
  overflow-x: hidden !important;
  overflow-y: hidden !important; 

  position: absolute !important; 
  top: ${({ isTop }) => (isTop ? `${isTop} !important` : "14px !important")};
  left: auto !important; 
  right: ${({ isRight }) => (isRight ? `${isRight} !important` : "14px !important")}; 
  z-index: 1050 !important; 

  .premium{
    ${'' /* color: #DA6C74; */}
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
  }
`;

export const CustomDropdownItemV1 = styled(Dropdown.Item)`
  font-family: "Lato" !important;
  font-size: ${({ isSize }) => (isSize ? `${isSize} !important` : "16px !important")}; 
  padding: 14px 16px !important;
  border-radius:4px  !important;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${({ active }) => (active ? "white" : "#184A61")} !important;
  background-color: ${({ active, bgColor  }) =>
    active ? bgColor  : "transparent"} !important;

    

  &:hover {
    border-radius: 4px !important;
    color: ${({ active }) => (active ? "white" : "white")} !important;
    background-color: ${({ bgColor  }) =>
    bgColor  ? bgColor  : "#088A96"} !important;
  }

  &:focus {
    outline: none;
    color: white !important;
    ${'' /* background-color: #088a96 !important; */}
    background-color: ${({ bgColor  }) =>
    bgColor  ? bgColor  : "#088A96"} !important;
    ${'' /* border: 2px solid #a1fffb !important; */}
    border-radius: 4px !important;
  }


  >img{
    height:32px !important;
    width:32px !important;
  }
`;



let pathName;

class Topbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideSideBar: false,
      selectedRole: this.props.t("User"), 
      // lang: localStorage.getItem('lang') || 'en' || 'es',
      lang: localStorage.getItem('lang'),
      showProfileImage: false,
    }
    this.myref = React.createRef();
  }

  collapsSideBar = () => {
    const { hideContentOfSideBar, handleResponsiveCheck, handleAdminResponsiveCheck } = this.props;
    this.setState({ hideSideBar: !this.state.hideSideBar });
    hideContentOfSideBar();
    handleResponsiveCheck();
    handleAdminResponsiveCheck();
  }

  takeLanguageData = (lang) => {
    const { putUpdateLanguage } = this.props;
    let obj = {
      user_language: lang === 'en' ? "english" : lang === 'es' ? 'Spanish' : lang === 'pt' ? 'Portuguese': 'French'
    };
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
    this.setState({ lang: lang });
    putUpdateLanguage(obj);
  };

  setRoleBasedOnPath = () => {
    let eventKey = this.props.history.location.pathname.split("/");
    if (eventKey[1]  === "manager") {
      this.setState({selectedRole:"Manager"})
    } else if (eventKey[1] === "company") {
      if(this.props.role === "ADMIN"){
        this.setState({selectedRole:"Super Admin"})
      }else{
        this.setState({selectedRole:"Admin"})
      }
      
    } else if (eventKey[1]  === "health-coach") 
    {
      this.setState({selectedRole: "Health Coach"})
    }
    else {
      this.setState({selectedRole:"User"})
    }
  }



  componentDidMount() {
    const { getLanguages } = this.props;
    const { lang } = this.state;
    let selectedUserLanguage;
    if(getLanguages && !isNull(getLanguages) &&!isUndefined(getLanguages)){
      getLanguages && getLanguages.length>0 && getLanguages.map((lang)=>{
        if(lang.user_selected===1){
          selectedUserLanguage=lang.name;
        }
      })
    }
    if(isNull(lang)){
      i18n.changeLanguage(selectedUserLanguage);
    }else{
      i18n.changeLanguage(lang);
    }
    this.setRoleBasedOnPath()
  }


  componentDidUpdate(prevProps){
    
    if(pathName !== this.props.history.location.pathname)
    {
      this.setRoleBasedOnPath();
      pathName=prevProps.history.location.pathname;
    }
  }

  toggleProfileSidebar = () => {
    this.setState((prev) => ({
      showProfileImage: !prev.showProfileImage
    }));
  };

  handleSelect = (eventKey) => {
    const roleIds = this.props.allRoles.map((r) => r.rid);
    const isNormalUser = roleIds.includes(2);
    // const isHealthCoach = roleIds.includes(17);

    const { history } = this.props;
    if (eventKey === "Manager") {
      localStorage.setItem("isManagerRole", "Manager");
      this.setState({selectedRole:eventKey})
      history.push('/manager/dashboard'); 
    } else if (eventKey === "Admin") {
      localStorage.setItem("isManagerRole", "Admin");
      this.setState({selectedRole:eventKey})
      history.push('/company/dashboard'); 
    }else if (eventKey === "Super Admin") {
      localStorage.setItem("isManagerRole", "Super Admin");
      this.setState({selectedRole:eventKey})
      history.push('/company/dashboard'); 
    } else if(eventKey === "Health Coach"){

      localStorage.setItem("isManagerRole", "Health Coach");
      this.setState({selectedRole:eventKey});
      history.push('/health-coach/dashboard');
    }else if (eventKey === "User") {
      if(isNormalUser){
        localStorage.setItem("isManagerRole", "User");
        this.setState({selectedRole:eventKey})
        history.push('/portal'); 
      }
    }
  };

 

  render() {
    const { history, logout, companyLogo, userDetails, profileImage, readStatusCount, adminPortalAccess, colorData, getLanguages, companyId, isAdminUser, role, managerPortalAccess, userCompany,healthCoachPortalAccess, allRoles } = this.props;
    let navIndex = colorData && colorData.color_branding && colorData.color_branding.length > 0 ? colorData.color_branding.findIndex((data) => data.custom_name === 'nav_bar_color') : -1;
    let getColor = navIndex !== -1 ? colorData?.color_branding[navIndex]?.color_code : "#ffff";
    let sideBarIndex = colorData && colorData.color_branding && colorData.color_branding.length > 0 ? colorData.color_branding.findIndex((data) => data.custom_name === 'side_menu_color') : -1;
    let getSideBarColor = sideBarIndex !== -1 && colorData?.color_branding[sideBarIndex]?.color_code || '#F37A65';
    let { lang, showProfileImage, selectedRole } = this.state;
    let selectedLanguage;
    if(getLanguages && !isNull(getLanguages) &&!isUndefined(getLanguages)){
      getLanguages && getLanguages.length>0 && getLanguages.map((lang)=>{
        if(lang.user_selected===1){
          selectedLanguage=lang.name;
        }
      })
    }
    let isManagerTrue = this.props.isManagerRole?.some((data) => data?.rid == 15);
    let isHealthCoachTrue = this.props.isManagerRole?.some((data) => data?.rid == 17);

    const path = history.location.pathname; // e.g., "/social/123"
    const segments = path.split('/')[1];

    const roleIds = allRoles.map((r) => r.rid);
    const isNormalUser = roleIds.includes(2);


    return <TopbarGrid backgroundColor={getColor}>
      <Logo color={getSideBarColor || 'rgb(11, 65, 112)'} height={1} hide={this.state.hideSideBar ? 1 : 0} width={companyId===83}>
        {!this.state.hideSideBar ? companyLogo
          ?
          <div className={'imageContainer'}>
            <img src={`${ImageUrl}/${segments === 'company' ? companyLogo : userCompany?.companyStartDate?.header_logo}`} alt="logo" 
              // onClick={() => history.push('/portal')} 
              onClick={()=>this.handleSelect("User")}
              
            />
          </div>
          :
          COMPANY_NAME === 'Woliba' ?
            <div className={'imageContainer'}>
              <img src="/public/images/NewSideBarV3//logo.png" alt="logo" onClick={() => history.push('/portal')} />
            </div>
            :
            <div className={'imageContainer'}>
              <img src="/public/images/Logo/training-amigo-horizontal-logo.png" alt="logo"
                onClick={() => history.push('/portal')} />
            </div>
          :
          <CollapsArrow onClick={this.collapsSideBar}>
            <svg width="20" height="22" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.6083 7.05099L8.95285 0.395524C8.42792 -0.1294 7.57658 -0.1294 7.05165 0.395524C6.52673 0.920448 6.52673 1.77179 7.05165 2.29672L12.7559 8.00092L7.05165 13.7051C6.52673 14.23 6.52673 15.0814 7.05165 15.6063C7.57658 16.1312 8.42792 16.1312 8.95285 15.6063L15.6083 8.95085C16.1332 8.42723 16.1332 7.57591 15.6083 7.05099Z"
                fill={getSideBarColor || '#0b4170'} opacity="0.5" />
              <path
                d="M7.6039 6.64798L2.32005 1.07901C1.78911 0.52013 0.92914 0.52013 0.398203 1.07901C-0.132734 1.6379 -0.132734 2.54453 0.398203 3.1041L4.72149 7.66052L0.398203 12.2169C-0.132734 12.7759 -0.132734 13.6831 0.398203 14.242C0.92914 14.8009 1.78911 14.8009 2.32005 14.242L7.6039 8.67306C8.13484 8.11418 8.13484 7.20754 7.6039 6.64798Z"
                fill={getSideBarColor || '#0b4170'} opacity="0.1" />
            </svg>
          </CollapsArrow>
        }
        {/* {this.state.hideSideBar ? null :
          <ArrowImg onClick={this.collapsSideBar}>
            <svg width="20" height="22" viewBox="0 0 17 16" fill="none">
              <path
                d="M0.393665 7.05099L7.04911 0.395524C7.57403 -0.1294 8.42538 -0.1294 8.9503 0.395524C9.47523 0.920448 9.47523 1.77179 8.9503 2.29672L3.24607 8.00092L8.9503 13.7051C9.47523 14.23 9.47523 15.0814 8.9503 15.6063C8.42538 16.1312 7.57403 16.1312 7.04911 15.6063L0.393665 8.95085C-0.131259 8.42723 -0.131259 7.57591 0.393665 7.05099Z"
                fill={getSideBarColor || '#0b4170'} fillOpacity="0.5" />
              <path
                d="M8.39805 6.64798L13.6819 1.07901C14.2128 0.52013 15.0728 0.52013 15.6038 1.07901C16.1347 1.6379 16.1347 2.54453 15.6038 3.1041L11.2805 7.66052L15.6038 12.2169C16.1347 12.7759 16.1347 13.6831 15.6038 14.242C15.0728 14.8009 14.2128 14.8009 13.6819 14.242L8.39805 8.67306C7.86711 8.11418 7.86711 7.20754 8.39805 6.64798Z"
                fill={getSideBarColor || '#0b4170'} fillOpacity="0.1" />
            </svg>
          </ArrowImg>
        } */}
      </Logo>
      <IconsWrapper>

        { selectedRole ==="Manager" ? <ManagerIconContainer>{LightThemeIcon(getSideBarColor)}</ManagerIconContainer> : null}
     

      
        {/* // { companyId !== 1 && companyId !== 18  && adminPortalAccess && <div>
        //   <ViewButton background={getSideBarColor} color={getSideBarColor} onClick={()=> history.location.pathname.includes('company') ? history.push('/portal') : history.push('/company/dashboard') }>{history.location.pathname.includes('company') ? this.props.t("View As Member") : this.props.t("View As Admin")}</ViewButton>
        // </div> 
        // } */}
        {/* {
          adminPortalAccess && <div><SvgIconContainer onClick={() => history.push('/company/dashboard')}
            active={history.location.pathname.includes('company')}
            color={getSideBarColor}>{dashboardIcon}</SvgIconContainer>
          </div>
        } */}
        { selectedRole !=="Manager" ? <Notification selectedRole={selectedRole} readStatusCount={readStatusCount} history={history} color={getSideBarColor} companyId={companyId} companyLogo={companyLogo}/> : null}
      
        {/* { getLanguages && getLanguages.length>1?
          <div>
            <Languagecontainer color={getSideBarColor}>
              <IconContainer 
                active={history.location.pathname.includes('community')} color={getSideBarColor}
              >
                {isNull(lang)?<img src={`/public/images/NewHeader/${selectedLanguage == 'en' ? "English.png" : selectedLanguage == 'es' ? "Spanish.png" :selectedLanguage == 'pt'? "Portuguese.png": "French.png"}`} />:<img src={`/public/images/NewHeader/${lang == 'en' ? "English.png" : lang == 'es' ? "Spanish.png" : lang == 'pt'? 'Portuguese.png': "French.png"}`} />}
              </IconContainer>
              <ul>
                {getLanguages.map((data, index)=>
                  (<li key={index}><a onClick={() => this.takeLanguageData(data.name)}><img src={`${ImageUrl}/${data.image}`} />{data.display_name}</a></li>))}
              </ul>
            </Languagecontainer>
          </div>
          : null
        } */}

        {getLanguages && getLanguages.length > 1 && (
          <DropdownWrapper isMargin={"0px 0px 0px 20px"}>
            <Dropdown onSelect={(eventKey) => this.takeLanguageData(eventKey)} style={{ cursor: "pointer" }}>
              <Dropdown.Toggle as={CustomToggle}>
                <CustomToggleWrapper>
                  <IconContainer isPadding={'10px 0px 10px 10px'} active={history.location.pathname.includes('community')} color={getSideBarColor} style={{display:'flex'}}>
                    <StyledImage
                      src={`/public/images/NewHeader/${
                        isNull(lang)
                          ? selectedLanguage === "fr"
                            ? "French.png"
                            : selectedLanguage === "es"
                              ? "Spanish.png"
                              : selectedLanguage === "pt"
                                ? "Portuguese.png"
                                : "English.png"
                          : lang === "fr"
                            ? "French.png"
                            : lang === "es"
                              ? "Spanish.png"
                              : lang === "pt"
                                ? "Portuguese.png"
                                : "English.png"
                      }`}
                      alt="Selected Language"
                    />
                    <div style={{marginLeft:"4px",color:"#184A61",fontFamily:"lato",fontSize:"16px"}}>
                      { selectedLanguage === "fr" ?
                        "FR" :
                        selectedLanguage === "es"?
                          "SP" :
                          selectedLanguage === "pt" ?
                            "PT" :
                            
                            lang === "fr" ?
                              "FR" :
                              lang === "es" ?
                                "SP" :
                                lang === "pt" ?
                                  "PT" :
                                  "EN" }
                    </div>
                  </IconContainer>
                  <span>{DropIcon(getSideBarColor)}</span>
                </CustomToggleWrapper>
              </Dropdown.Toggle>
              <CustomMenuV1 align="end" isRight={'-70px'} isTop={'16px'} >
                {getLanguages.map((data, index) => (
                  <CustomDropdownItemV1 bgColor={getSideBarColor} key={index} eventKey={data.name} style={{display:'flex'}}>
                    <img src={`${ImageUrl}/${data.image}`} alt={data.display_name} style={{ marginRight: "8px" }} />
                    <div style={{ textTransform: 'capitalize',display:"flex",alignItems:'center',justifyContent:'center'}}>{data.display_name}</div> 
                  </CustomDropdownItemV1>
                ))}
              </CustomMenuV1>
            </Dropdown>
          </DropdownWrapper>
        )}


    
        { (adminPortalAccess || managerPortalAccess || healthCoachPortalAccess ) ? 
          <DropdownWrapper>
            <Dropdown onSelect={this.handleSelect} style={{ cursor: "pointer"}}>
              <Dropdown.Toggle as={CustomToggle} >
                <CustomToggleWrapper>
                  {selectedRole}
                  <span className="dropdown-arrow">{DropIcon(getSideBarColor)}</span> 
                </CustomToggleWrapper>
              </Dropdown.Toggle>
              <CustomMenuV1 align="end" isRight={'-70px'} isTop={'16px'}>
                {isAdminUser&&<CustomDropdownItemV1 bgColor={getSideBarColor} eventKey="Admin">{this.props.t("Admin")}</CustomDropdownItemV1>}
                {isManagerTrue&&<CustomDropdownItemV1 bgColor={getSideBarColor} eventKey="Manager">{this.props.t("Manager")}</CustomDropdownItemV1>}
                {isHealthCoachTrue && <CustomDropdownItemV1 bgColor={getSideBarColor} eventKey="Health Coach">{this.props.t("Health Coach")}</CustomDropdownItemV1>}
                <CustomDropdownItemV1 bgColor={getSideBarColor} eventKey="User">{this.props.t("User")}{!isNormalUser && isHealthCoachTrue && <><Border background={"#DCDCDC"} margin={'4px 0px'}/><div className='premium'>Upgrade To Premium</div></>}</CustomDropdownItemV1>
                {role === "ADMIN" && <CustomDropdownItemV1 bgColor={getSideBarColor} eventKey="Super Admin">{this.props.t("Super Admin")}</CustomDropdownItemV1>}
              </CustomMenuV1>
             
            </Dropdown>
          </DropdownWrapper>
          :null
        }
        <div>
          <NameContainer /*onClick={() => history.push('/buddy-search')}*/
            /*active={history.location.pathname.includes('buddy-search')}*/ color={getSideBarColor}
          >
            <p><span>{userDetails && userDetails.fname}</span></p>
          </NameContainer>
        </div>
        {userDetails && userDetails.profile_image&&<div>
          <ProfileImg color={getSideBarColor} onClick={this.toggleProfileSidebar}>
            <Img
              alt={userDetails && userDetails.fname}
              src={checkBase64(profileImage || userDetails.profile_image)}
              unloader={
                <Img
                  src='/public/images/neutral_avatar.svg'
                  alt='avatar'
                />
              }
            />
          </ProfileImg>
        </div>}
        {showProfileImage ?
          <UserProfile innerRef={this.myref} history={history} logout={logout} profileImage={profileImage} color={getSideBarColor} userDetails={userDetails} showProfileImage={showProfileImage} closeModal={this.toggleProfileSidebar}/>
          : ''}
      </IconsWrapper>
    </TopbarGrid>
  }
}

Topbar.propTypes = {
  history: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  isManager:PropTypes.bool.isRequired,
  companyLogo: PropTypes.string,
  userDetails: PropTypes.object.isRequired,
  profileImage: PropTypes.string,
  readStatusCount: PropTypes.object,
  getReadStatusCountForNotification: PropTypes.func,
  adminPortalAccess: PropTypes.bool,
  colorData: PropTypes.object,
  hideContentOfSideBar: PropTypes.func,
  handleResponsiveCheck: PropTypes.func.isRequired,
  handleAdminResponsiveCheck: PropTypes.func.isRequired,
  putUpdateLanguage: PropTypes.func,
  userCompany: PropTypes.object,
  showProfileImage: PropTypes.bool,
  getLanguages: PropTypes.array,
  companyId: PropTypes.number,
  t: PropTypes.func,
  isManagerRole: PropTypes.array,
  isManagerUser: PropTypes.bool,
  isAdminUser: PropTypes.bool,
  role:PropTypes.string,
  managerPortalAccess:PropTypes.bool,
  healthCoachPortalAccess:PropTypes.bool,
  allRoles:PropTypes.array
}

const mapStateToProps = (state) => ({
  userCompany: state.profileData.userCompany,
  isManagerRole: state.profileData.isManagerRole,
  isManagerUser: state.profileData.isManagerUser,
  isAdminUser: state.profileData.isAdminUser,
  allRoles: state.profileData.allRoles,
})

const mapDispatchToProps = (dispatch) => ({
  putUpdateLanguage: (obj) => dispatch(putUpdateLanguage(obj))
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)((withTranslation())(Topbar)));
